/**
 * Sport Icon Mapping - Mix of Emojis and Custom SVGs
 * Returns either emoji character or React component for custom sports
 */

import React from 'react';

// Custom SVG Components for sports without emoji representation or needing distinct icons

// Racquet Sport Icons - Each with distinct racquet shape
export const SquashRacquetIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="8" rx="6" ry="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <line x1="12" y1="15" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 6 L16 6 M8 8 L16 8 M8 10 L16 10 M10 5 L10 12 M12 5 L12 12 M14 5 L14 12" stroke="currentColor" strokeWidth="0.5"/>
  </svg>
);

export const RacquetballRacquetIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="7" rx="7" ry="8" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <line x1="12" y1="15" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 5 L17 5 M7 7 L17 7 M7 9 L17 9 M9 4 L9 11 M12 4 L12 11 M15 4 L15 11" stroke="currentColor" strokeWidth="0.5"/>
  </svg>
);

export const PadelRacquetIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="3" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <line x1="12" y1="15" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="9" cy="6" r="0.8" fill="currentColor"/>
    <circle cx="12" cy="6" r="0.8" fill="currentColor"/>
    <circle cx="15" cy="6" r="0.8" fill="currentColor"/>
    <circle cx="9" cy="9" r="0.8" fill="currentColor"/>
    <circle cx="12" cy="9" r="0.8" fill="currentColor"/>
    <circle cx="15" cy="9" r="0.8" fill="currentColor"/>
    <circle cx="9" cy="12" r="0.8" fill="currentColor"/>
    <circle cx="12" cy="12" r="0.8" fill="currentColor"/>
    <circle cx="15" cy="12" r="0.8" fill="currentColor"/>
  </svg>
);

export const PickleballPaddleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="7" y="4" width="10" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <line x1="12" y1="14" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="10" cy="7" r="0.7" fill="currentColor"/>
    <circle cx="14" cy="7" r="0.7" fill="currentColor"/>
    <circle cx="10" cy="10" r="0.7" fill="currentColor"/>
    <circle cx="14" cy="10" r="0.7" fill="currentColor"/>
    <circle cx="12" cy="8.5" r="0.7" fill="currentColor"/>
  </svg>
);

// Athletics Icons - Based on reference silhouettes
export const JavelinIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Head */}
    <circle cx="8" cy="6" r="2" fill="currentColor"/>
    {/* Body - throwing stance */}
    <path d="M7 8 L7 12 L5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 8 L10 11 L12 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Back arm with javelin */}
    <line x1="10" y1="9" x2="22" y2="3" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M20 3.5 L22 3 L21.5 4.5" fill="currentColor"/>
  </svg>
);

export const ShotPutIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Head */}
    <circle cx="12" cy="5" r="2" fill="currentColor"/>
    {/* Body in throwing position - wide stance */}
    <ellipse cx="12" cy="15" rx="6" ry="8" fill="currentColor"/>
    <circle cx="12" cy="10" r="3.5" fill="currentColor"/>
    {/* Arms - one holding shot put */}
    <path d="M8 11 Q6 12 6 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 11 Q18 10 20 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    {/* Shot put ball */}
    <circle cx="18" cy="9" r="2.5" fill="currentColor"/>
    {/* Circle marking */}
    <ellipse cx="12" cy="20" rx="8" ry="1.5" stroke="currentColor" strokeWidth="1" fill="none"/>
  </svg>
);

export const HammerThrowIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Head */}
    <circle cx="10" cy="10" r="2" fill="currentColor"/>
    {/* Body in spinning stance */}
    <path d="M8 12 Q10 15 12 17" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M12 12 Q14 15 14 17" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    {/* Arms extended holding hammer */}
    <path d="M10 11 L8 8 L10 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 11 L14 8 L16 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    {/* Hammer wire and ball */}
    <line x1="16" y1="6" x2="20" y2="3" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="21" cy="2" r="2.5" fill="currentColor"/>
  </svg>
);

export const DivingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="4" r="1.5" fill="currentColor"/>
    <path d="M14 6 L16 8 L18 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="16" y1="8" x2="16" y2="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14 10 L18 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <rect x="2" y="18" width="14" height="2" rx="1" fill="currentColor"/>
    <line x1="10" y1="18" x2="10" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="8" y1="14" x2="12" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const HighJumpIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Head */}
    <circle cx="14" cy="6" r="2" fill="currentColor"/>
    {/* Body arched over bar (Fosbury Flop) */}
    <path d="M12 8 Q16 10 18 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    <path d="M10 10 Q12 11 14 11" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M16 11 Q18 10 19 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    {/* Bar */}
    <line x1="4" y1="13" x2="20" y2="13" stroke="currentColor" strokeWidth="1.5"/>
    {/* Posts */}
    <line x1="4" y1="13" x2="4" y2="20" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="20" y1="13" x2="20" y2="20" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

export const PoleVaultIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Head */}
    <circle cx="10" cy="6" r="2" fill="currentColor"/>
    {/* Body vaulting over */}
    <path d="M8 8 Q9 10 11 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 8 Q14 9 15 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    {/* Arms holding pole */}
    <line x1="8" y1="8" x2="6" y2="12" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="12" y1="9" x2="10" y2="13" stroke="currentColor" strokeWidth="1.5"/>
    {/* Pole */}
    <line x1="10" y1="7" x2="4" y2="22" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    {/* Bar */}
    <line x1="3" y1="12" x2="18" y2="12" stroke="currentColor" strokeWidth="1.5"/>
    {/* Posts */}
    <line x1="3" y1="12" x2="3" y2="19" stroke="currentColor" strokeWidth="1"/>
    <line x1="18" y1="12" x2="18" y2="19" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

/**
 * Get the appropriate emoji or SVG component for a sport
 * Returns either emoji string or React component
 */
export const getSportEmoji = (sportId, sportName = '') => {
  const id = sportId?.toLowerCase() || '';
  const name = sportName?.toLowerCase() || '';
  
  // Football variations - with correct ball types
  if (id === 'football' || id.includes('soccer') || name.includes('soccer')) {
    return '⚽'; // Football/Soccer - round ball
  }
  if (id === 'american-football' || name === 'american football') {
    return '🏈'; // American Football (NFL oval ball)
  }
  if (id === 'australian-rules' || name === 'australian rules football') {
    return '🏈'; // Australian Rules Football (oval ball like NFL)
  }
  if (id === 'rugby-union' || id === 'rugby-league' || id.includes('rugby') || name.includes('rugby')) {
    return '🏉'; // Rugby (different oval ball)
  }
  if (id.includes('basketball') || name.includes('basketball')) {
    return '🏀'; // Basketball
  }
  if (id.includes('cricket') || name.includes('cricket')) {
    return '🏏'; // Cricket
  }
  if (id.includes('tennis') || name.includes('tennis')) {
    return '🎾'; // Tennis
  }
  if (id.includes('badminton') || name.includes('badminton')) {
    return '🏸'; // Badminton
  }
  if (id.includes('table-tennis') || id.includes('ping-pong') || name.includes('table tennis') || name.includes('ping pong')) {
    return '🏓'; // Table Tennis
  }
  if (id.includes('volleyball') || name.includes('volleyball')) {
    return '🏐'; // Volleyball
  }
  if (id.includes('baseball') || name.includes('baseball')) {
    return '⚾'; // Baseball
  }
  if (id.includes('softball') || name.includes('softball')) {
    return '🥎'; // Softball
  }
  if (id.includes('handball') || name.includes('handball')) {
    return '🤾'; // Handball
  }
  // Hockey - field vs ice with stick emojis  
  if (id === 'ice-hockey' || name === 'ice hockey') {
    return '🏒'; // Ice Hockey (stick and puck)
  }
  if (id === 'hockey' || name.includes('hockey')) {
    return '🏑'; // Field Hockey (stick and ball) - default for general "hockey"
  }
  if (id.includes('lacrosse') || name.includes('lacrosse')) {
    return '🥍'; // Lacrosse
  }
  if (id.includes('frisbee') || id.includes('disc') || name.includes('frisbee') || name.includes('disc')) {
    return '🥏'; // Flying Disc
  }
  
  // Racquet sports - using specific racquet emojis and custom SVGs
  if (id.includes('badminton') || name.includes('badminton')) {
    return '🏸'; // Badminton - has specific emoji (shuttlecock)
  }
  if (id.includes('table-tennis') || id.includes('ping-pong') || name.includes('table tennis') || name.includes('ping pong')) {
    return '🏓'; // Table Tennis - has specific emoji (paddle)
  }
  if (id.includes('tennis') || name.includes('tennis')) {
    return '🎾'; // Tennis - has specific emoji (ball)
  }
  // Custom SVG racquets for sports without specific emojis
  if (id.includes('squash') || name.includes('squash')) {
    return 'SquashRacquet'; // Custom SVG - small round racquet
  }
  if (id.includes('racquetball') || name.includes('racquetball')) {
    return 'RacquetballRacquet'; // Custom SVG - larger round racquet
  }
  if (id.includes('padel') || name.includes('padel')) {
    return 'PadelRacquet'; // Custom SVG - solid paddle with holes
  }
  if (id.includes('pickleball') || name.includes('pickleball')) {
    return 'PickleballPaddle'; // Custom SVG - smaller paddle
  }
  
  // Combat sports - with variations
  if (id.includes('boxing') && !id.includes('kick') || (name.includes('boxing') && !name.includes('kick'))) {
    return '🥊'; // Pure Boxing
  }
  if (id.includes('kickboxing') || id.includes('muay-thai') || name.includes('kickboxing') || name.includes('muay thai')) {
    return '🥊'; // Kickboxing/Muay Thai (use boxing glove - no separate emoji available)
  }
  if (id.includes('wrestling') || name.includes('wrestling')) {
    return '🤼'; // Wrestling - distinct from martial arts uniforms
  }
  if (id.includes('mma') || id.includes('mixed-martial') || name.includes('mixed martial')) {
    return '🤼'; // MMA - use wrestling emoji (grappling-focused)
  }
  if (id.includes('karate') || id.includes('judo') || id.includes('taekwondo') || 
      id.includes('jiu-jitsu') || id.includes('kung-fu') || id.includes('aikido') ||
      name.includes('karate') || name.includes('judo') || name.includes('taekwondo')) {
    return '🥋'; // Traditional Martial Arts with uniforms
  }
  if (id.includes('kendo') || name.includes('kendo')) {
    return '⚔️'; // Kendo - uses swords
  }
  if (id.includes('silat') || name.includes('silat')) {
    return '🗡️'; // Silat - knife/blade techniques
  }
  if (id.includes('fencing') || name.includes('fencing')) {
    return '🤺'; // Fencing
  }
  
  // Water sports - specific types
  if (id.includes('swimming') || name.includes('swimming') || name.includes('swim')) {
    return '🏊'; // Swimming
  }
  if (id.includes('diving') || name.includes('diving')) {
    return 'Diving'; // Custom SVG - person on springboard
  }
  if (id.includes('scuba') || name.includes('scuba')) {
    return '🤿'; // Scuba diving mask
  }
  if (id.includes('water-polo') || name.includes('water polo')) {
    return '🤽'; // Water Polo
  }
  if (id.includes('surfing') || name.includes('surfing')) {
    return '🏄'; // Surfing
  }
  if (id.includes('rowing') || id.includes('canoe') || id.includes('kayak') || name.includes('rowing')) {
    return '🚣'; // Rowing
  }
  if (id.includes('sailing') || name.includes('sailing')) {
    return '⛵'; // Sailing
  }
  
  // Athletics & Track Field - specific events with custom SVGs
  if (id.includes('running') || id.includes('sprint') || id.includes('marathon') || 
      id.includes('track') && !id.includes('cycling') || name.includes('running') || name.includes('athletics')) {
    return '🏃'; // Running
  }
  if (id.includes('long-jump') || name.includes('long jump')) {
    return '🏃'; // Long Jump (running approach)
  }
  if (id.includes('triple-jump') || name.includes('triple jump')) {
    return '🏃'; // Triple Jump (running)
  }
  if (id.includes('high-jump') || name.includes('high jump')) {
    return 'HighJump'; // Custom SVG - person jumping over bar
  }
  if (id.includes('pole-vault') || name.includes('pole vault')) {
    return 'PoleVault'; // Custom SVG - person with pole over bar
  }
  if (id.includes('hurdles') || name.includes('hurdles')) {
    return '🏃'; // Hurdles (running)
  }
  if (id.includes('javelin') || name.includes('javelin')) {
    return 'Javelin'; // Custom SVG - person throwing spear
  }
  if (id.includes('shot-put') || name.includes('shot put')) {
    return 'ShotPut'; // Custom SVG - person with ball under chin
  }
  if (id.includes('hammer') || name.includes('hammer throw')) {
    return 'HammerThrow'; // Custom SVG - ball with chain
  }
  if (id.includes('discus') || name.includes('discus')) {
    return '🥏'; // Discus (flying disc)
  }
  
  // Cycling - different types
  if (id.includes('cycling') || id.includes('bike') || id === 'road-cycling' || 
      name.includes('cycling') || name.includes('biking')) {
    return '🚴'; // Cycling
  }
  if (id === 'track-cycling' || name === 'track cycling') {
    return '🚴'; // Track Cycling (velodrome)
  }
  if (id.includes('mountain-bike') || id.includes('mountain_bike') || 
      (name.includes('mountain') && name.includes('bike'))) {
    return '🚵'; // Mountain Biking
  }
  if (id.includes('bmx') || name.includes('bmx')) {
    return '🚴'; // BMX
  }
  
  // Winter sports - specific types
  if (id.includes('ski') && !id.includes('jet') || name.includes('skiing')) {
    return '⛷️'; // Skiing
  }
  if (id.includes('snowboard') || name.includes('snowboard')) {
    return '🏂'; // Snowboarding
  }
  if (id.includes('ice-skating') || id.includes('figure-skating') || name.includes('skating')) {
    return '⛸️'; // Ice Skating
  }
  if (id.includes('curling') || name.includes('curling')) {
    return '🥌'; // Curling
  }
  if (id.includes('bobsleigh') || id.includes('bobsled') || name.includes('bobsleigh') || name.includes('bobsled')) {
    return '🛷'; // Bobsleigh (sled)
  }
  if (id.includes('skeleton') || name.includes('skeleton')) {
    return '🛷'; // Skeleton (sled)
  }
  if (id.includes('luge') || name.includes('luge')) {
    return '🛷'; // Luge (sled)
  }
  if (id.includes('sled') || name.includes('sled')) {
    return '🛷'; // General sledding
  }
  
  // Strength & Fitness
  if (id.includes('weightlifting') || id.includes('powerlifting') || id.includes('bodybuilding') ||
      name.includes('weight') || name.includes('lifting')) {
    return '🏋️'; // Weightlifting
  }
  
  // Gymnastics & related
  if (id.includes('gymnastics') || name.includes('gymnastics')) {
    return '🤸'; // Gymnastics
  }
  
  // Precision sports - target-based
  if (id.includes('golf') || name.includes('golf')) {
    return '⛳'; // Golf
  }
  if (id.includes('archery') || id.includes('bow') || name.includes('archery')) {
    return '🏹'; // Archery
  }
  if (id.includes('shooting') || id.includes('rifle') || id.includes('pistol') || name.includes('shooting')) {
    return '🎯'; // Shooting Sports (target/bullseye)
  }
  if (id.includes('darts') || name.includes('darts')) {
    return '🎯'; // Darts/Target
  }
  if (id.includes('bowling') || name.includes('bowling')) {
    return '🎳'; // Bowling
  }
  if (id.includes('billiards') || id.includes('pool') || id.includes('snooker') || name.includes('billiards')) {
    return '🎱'; // Billiards
  }
  
  // Climbing
  if (id.includes('climbing') || id.includes('bouldering') || name.includes('climbing')) {
    return '🧗'; // Climbing
  }
  
  // Equestrian
  if (id.includes('equestrian') || id.includes('horse') || name.includes('horse') || name.includes('equestrian')) {
    return '🏇'; // Horse Racing/Equestrian
  }
  
  // Motor sports (use flag as motorsport doesn't have specific emoji)
  if (id.includes('motorsport') || id.includes('racing') || id.includes('formula') || 
      id.includes('car-racing') || name.includes('racing') || name.includes('formula')) {
    return '🏁'; // Racing Flag
  }
  
  // Skateboarding
  if (id.includes('skateboard') || name.includes('skateboard')) {
    return '🛹'; // Skateboarding
  }
  
  // Dance & similar
  if (id.includes('dance') || id.includes('ballet') || name.includes('dance')) {
    return '💃'; // Dancing
  }
  
  // Yoga & meditation
  if (id.includes('yoga') || id.includes('meditation') || name.includes('yoga')) {
    return '🧘'; // Yoga
  }
  
  // Chess
  if (id.includes('chess') || name.includes('chess')) {
    return '♟️'; // Chess
  }
  
  // Fishing
  if (id.includes('fishing') || name.includes('fishing')) {
    return '🎣'; // Fishing
  }
  
  // Generic sports - use trophy for unmatched sports
  if (id.includes('sport') || name.includes('sport')) {
    return '🏆'; // Trophy for generic sports
  }
  
  // Indian sports
  if (id.includes('kabaddi') || name.includes('kabaddi')) {
    return '🤼'; // Wrestling emoji (closest match)
  }
  if (id.includes('kho-kho') || name.includes('kho kho')) {
    return '🏃'; // Running (tag sport)
  }
  
  // Team sports without specific emojis
  if (id.includes('futsal') || name.includes('futsal')) {
    return '⚽'; // Use soccer ball
  }
  if (id.includes('netball') || name.includes('netball')) {
    return '🏀'; // Use basketball (similar)
  }
  
  // Default fallback - trophy
  return '🏆';
};

/**
 * Get emoji for sport category
 */
export const getCategoryEmoji = (categoryId) => {
  const id = categoryId?.toLowerCase() || '';
  
  if (id.includes('indoor') || id.includes('court')) return '🎾';
  if (id.includes('team')) return '⚽';
  if (id.includes('combat') || id.includes('martial')) return '🥊';
  if (id.includes('field')) return '⚽';
  if (id.includes('athletics') || id.includes('track')) return '🏃';
  if (id.includes('ice') || id.includes('winter')) return '⛷️';
  if (id.includes('aquatic') || id.includes('water')) return '🏊';
  if (id.includes('cycling') || id.includes('endurance')) return '🚴';
  if (id.includes('strength') || id.includes('conditioning')) return '🏋️';
  if (id.includes('mind') || id.includes('precision')) return '🎯';
  if (id.includes('gymnastics')) return '🤸';
  if (id.includes('emerging') || id.includes('alternative')) return '🛹';
  
  return '🏆'; // Default trophy
};

/**
 * Gold filter style for emojis
 */
export const goldEmojiStyle = {
  filter: 'grayscale(100%) sepia(100%) hue-rotate(10deg) saturate(400%) brightness(1.2)'
};

/**
 * Check if a sport belongs to Indoor/Court Sports category
 * These sports will show in original colors for better distinction
 */
export const isIndoorCourtSport = (sportId) => {
  const indoorCourtSports = [
    'squash', 'racquetball', 'padel', 'pickleball',
    'badminton', 'table-tennis', 'tennis'
  ];
  return indoorCourtSports.includes(sportId?.toLowerCase());
};

/**
 * Get emoji style based on sport category
 * Indoor/Court Sports show original colors, others show gold
 */
export const getEmojiStyle = (sportId) => {
  return isIndoorCourtSport(sportId) ? {} : goldEmojiStyle;
};
